import { init as loginInit } from "./actions/auth";

export default async function init(store) {
  await loginInit(store);
}
